// types
import {ContentPeerTargetTypeActionTypes, ContentPeerTargetTypeState, ContentPeerTargetTypeType} from "./types";
import {NewEmptyActionsItem} from "../../types";

export const INIT_STATE_CONTENT_PEER_TARGET_TYPE: ContentPeerTargetTypeState = {
  items: [],
};

const ContentPeerTargetType = (state = INIT_STATE_CONTENT_PEER_TARGET_TYPE, action: any) => {
  switch (action.type) {
    case ContentPeerTargetTypeActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case ContentPeerTargetTypeActionTypes.GET_CONTENT_PEER_TARGET_TYPES:
          return {
            ...state,
            items: action.payload.data.items,
            isPeerTargetTypeFetched: true,
            getPeerTargetTypeLoading: false,
          };
        default:
          return { ...state };
      }

    case ContentPeerTargetTypeActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case ContentPeerTargetTypeActionTypes.GET_CONTENT_PEER_TARGET_TYPES:
          return {
            ...state,
            isPeerTargetTypeFetched: false,
            getPeerTargetTypeLoading: false,
          };
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default ContentPeerTargetType;
